import { render, staticRenderFns } from "./legal-notice-malaysia.vue?vue&type=template&id=6eee7cf7&scoped=true&"
import script from "./legal-notice-malaysia.vue?vue&type=script&lang=ts&"
export * from "./legal-notice-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./legal-notice-malaysia.vue?vue&type=style&index=0&id=6eee7cf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eee7cf7",
  null
  
)

export default component.exports